import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";
import { OrganizationType } from "../components/main/body/screens/IAM/Users/types/OrganizationType";

interface UserProfile {
    username: string;
    email: string;
    name: string;
    familyName: string;
    customType: string;
    phoneNumber: string;
    gender: string;
    isApproved:string | any,
    showfield:string,
    enableNotification:string
  }

  
export class EditProfileStore {
    profile: UserProfile = {
        username: "",
        email: "",
        name: "",
        familyName: "",
        customType: "",
        phoneNumber: '57423',
        gender: "",
        isApproved:"",
        showfield:"false",
        enableNotification: ""
      };
      selectedOrg: string = "-1";
      initialOrg: string = "-1";
      organizationList: OrganizationType[] = [];

     

      rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    setProfile(newProfile: Partial<UserProfile>) {
        this.profile = { ...this.profile, ...newProfile };
      }
    get getProfile() {
        return this.profile;
    }

    setSelectedOrd = (orgId: any) => {
      this.selectedOrg = orgId;
    }
    get getSelectedOrg() {
      return this.selectedOrg;
    }

    setInitialOrd = (orgId: string) => {
      this.initialOrg = orgId;
    }
    get getInitialOrg() {
      return this.initialOrg;
    }

    setOrganizationList = (orgList: OrganizationType[]) => {
      this.organizationList = orgList;
    }
    get getOrganizationList() {
      return this.organizationList;
    }
}